/* 🤖 this file was generated by svg-to-ts */
export const matIconCameraRear: {
  name: 'camera-rear';
  data: string;
} = {
  name: 'camera-rear',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7V2h10v14zm-5-9c1.1 0 2-.9 1.99-2 0-1.1-.9-2-2-2S10 3.9 10 5s.89 2 2 2z"/></svg>`
};
